import { Controller } from "@hotwired/stimulus"

// Ads dashboard metric tiles: tapping one focuses the trend chart on that series (ads-metric:focus → ads-trend-chart)
// and the indicator slides under it; tapping it again goes back to impressions + clicks.
export default class extends Controller {
  static targets = ["tile", "indicator"]

  focus(event) {
    const tile = event.currentTarget
    const active = tile.getAttribute("aria-pressed") !== "true"
    this.tileTargets.forEach((t) => t.setAttribute("aria-pressed", String(active && t === tile)))

    if (this.hasIndicatorTarget) {
      this.indicatorTarget.classList.toggle("is-shown", active)
      // CSS places the ring by tile index (equal thirds), so it stays right through resize and rotation.
      if (active) this.indicatorTarget.style.setProperty("--i", this.tileTargets.indexOf(tile))
    }

    window.dispatchEvent(new CustomEvent("ads-metric:focus", { detail: { metric: active ? tile.dataset.metric : null } }))
  }
}
